import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet-async";
import "./AdminLogin.css";
import { getOtp,verifyOtp } from "../../Services";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // ✅ Send OTP
  const handleSendOtp = async () => {
   if (!email) return toast.error("Please enter email");

   try {
     await getOtp(email);
     toast.success("OTP sent successfully!");
     setOtpSent(true);
   } catch (err) {
     toast.error(err.response?.data?.error || "Failed to send OTP");
   }
  };

  // ✅ Verify OTP
  const handleLogin = async () => {
    if (!otp || otp.length !== 6) {
      toast.error("Please enter a valid 6-digit OTP");
      return;
    }
    try {
      await verifyOtp({ email, otp });
      toast.success("Login successful!");
      navigate("/admin-dashboard");
    } catch (err) {
      toast.error(err.response?.data?.error || "Invalid OTP");
    }
  };

  return (
    <div className="login-page" >
      <Helmet>
        <title>Admin Login | Manav Adhikar Forum</title>
        <meta
          name="description"
          content="Secure login page for the admin panel of Manav Adhikar Forum."
        />
      </Helmet>

      {/* ✅ Background */}
      <div className="login-background">
        <img src="/badge.png" alt="Badge" className="login-badge" />
      </div>

      {/* ✅ Centered Card */}
      <div className="login-card">
        <h1 className="login-title">Admin Login</h1>

        {/* Email Input */}
        <div className="form-group">
          <label className="text-muted fw-semibold">Email Address</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={otpSent}
            placeholder="Enter your admin email"
          />
        </div>

        {!otpSent ? (
          <button
            className="btn-primary"
            onClick={handleSendOtp}
            disabled={loading}
          >
            {loading ? "Sending..." : "Send OTP"}
          </button>
        ) : (
          <>
            {/* OTP Input */}
            <div className="form-group">
              <label>Enter OTP</label>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                maxLength="6"
                placeholder="6-digit OTP"
              />
            </div>
            <button
              className="btn-primary"
              onClick={handleLogin}
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login Now"}
            </button>
          </>
        )}
      </div>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default AdminLogin;
